import type { Layout } from '@mentimeter/http-clients';

/*
NinePoint(tm)
| 0,0 | 1,0 | 2,0 |
| 0,1 | 1,1 | 2,1 |
| 0,2 | 1,2 | 2,2 |
 */

// Based on flex column direction
const ninePointMap = {
  textAlign: [
    ['left', 'left', 'left'],
    ['center', 'center', 'center'],
    ['right', 'right', 'right'],
  ],
  alignItems: [
    ['flex-start', 'flex-start', 'flex-start'],
    ['center', 'center', 'center'],
    ['flex-end', 'flex-end', 'flex-end'],
  ],
  justifyContent: [
    ['flex-start', 'center', 'flex-end'],
    ['flex-start', 'center', 'flex-end'],
    ['flex-start', 'center', 'flex-end'],
  ],
} as const;

export const getNinePointLayoutProperties = (
  layout: Layout | null | undefined,
) => {
  const x = layout?.alignment_x ?? 1;
  const y = layout?.alignment_y ?? 1;
  const textAlign = ninePointMap.textAlign[x][y];
  const justifyContent = ninePointMap.justifyContent[x][y];
  const alignItems = ninePointMap.alignItems[x][y];
  return { textAlign, justifyContent, alignItems };
};
